import { useState } from "react"
import {
  Block,
  Button,
  Checkbox,
  HeadingLarge,
  LabelMedium,
  ParagraphXSmall,
  useStyletron,
} from "@mezo-org/mezo-clay"
import { useLocalStorage } from "usehooks-ts"

import ilustrationSrc from "#/assets/latest-update.png"
import { selectUsername, useDappSelector } from "#/redux-state"
import {
  IS_MEZO_MAINNET,
  LOCAL_STORAGE_MAINNET_WELCOME_MODAL_VISIBLE,
} from "#/shared/constants"

import BaseModal from "./BaseModal"

function MainnetWelcomeModal() {
  const [shouldRenderModal, setShouldRenderModal] = useLocalStorage(
    LOCAL_STORAGE_MAINNET_WELCOME_MODAL_VISIBLE,
    IS_MEZO_MAINNET,
  )

  const [acceptedTerms, setAcceptedTerms] = useState(false)

  const [, theme] = useStyletron()

  const username = useDappSelector(selectUsername)

  return (
    <BaseModal
      isOpen={shouldRenderModal}
      closeable={false}
      overrides={{
        Dialog: {
          style: {
            height: "100%",
          },
        },
      }}
    >
      <Block padding={theme.sizing.scale800}>
        <Block
          as="img"
          src={ilustrationSrc}
          width="100%"
          marginBottom={theme.sizing.scale600}
          overrides={{
            Block: {
              style: {
                borderRadius: theme.borders.radius500,
              },
            },
          }}
        />
        <LabelMedium marginBottom={theme.sizing.scale600}>
          Welcome to Mezo mainnet{username ? `, ${username}` : ""}!
        </LabelMedium>
        {/* TODO: Update copy */}
        <HeadingLarge marginBottom={theme.sizing.scale500}>
          Maynet is live. Maynet is live. Maynet is live.
        </HeadingLarge>

        <Checkbox
          checked={acceptedTerms}
          onChange={(e) => setAcceptedTerms(e.target.checked)}
          overrides={{
            Root: {
              style: {
                marginTop: theme.sizing.scale400,
                marginBottom: theme.sizing.scale800,
              },
            },
            Checkmark: {
              style: {
                width: theme.sizing.scale600,
                height: theme.sizing.scale600,
              },
            },
          }}
        >
          <ParagraphXSmall>I accept the Terms of Mezo mainnet.</ParagraphXSmall>
        </Checkbox>
        <Button
          width="100%"
          onClick={() => setShouldRenderModal(false)}
          disabled={!acceptedTerms}
        >
          I Agree
        </Button>
      </Block>
    </BaseModal>
  )
}

export default MainnetWelcomeModal
